import "./accountTotal.css";
import cleanAndFormatNumber from "./cleanAndFormatNumber";


function AccountTotal ({namesPaid, dataAccount}) {

    let num = dataAccount.sumR * dataAccount.numOfNames;

    Object.values(namesPaid).map((value) => {
        if (dataAccount.sumR >= value) {
            num -= value;
        } else {
            num -= 350;
        }
    })

    return (<>
        <div className="account-aufa-total-continer">
            <div>
                <p>מס' אנשים</p>
                <p> {dataAccount.numOfNames} </p>
            </div>

            <div>
                <p>סה"כ חיוב</p>
                <p style={{'color': 'red'}}>{dataAccount.sum * dataAccount.numOfNames}$</p>
            </div>

            <div>
                <p>סה"כ זיכוי</p>
                <p style={{'color': 'green'}}>{dataAccount.sumInvoices}$</p>
            </div>

            <div>   
                <p>יתרת תשלום</p>
                <p style={{'fontWeight': 'bold'}}>{cleanAndFormatNumber(dataAccount.sum * dataAccount.numOfNames - dataAccount.sumInvoices)}$</p>
            </div>

            <div>
                <p>יתרת תשלום לסגירת הזמנה</p>
                <p style={{'fontWeight': 'bold'}}>
                    {cleanAndFormatNumber(num > 0 ? num : 0)}$
                </p>
            </div>
        </div> 
    </>)
}

export default AccountTotal;